export const enableAlwaysHoverOnTouchDevices = () => {
  const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0

  if (isTouchDevice) {
    document.body.classList.add("always-hover")
  }
}
